export default "__VITE_ASSET__CdVxxIS2__"